<template>
    <div>
        <o-tabs :model-value="activeTab" @update:model-value="changeTab" type="is-boxed is-hd-wide">
          <o-tab-item :value="0" label="Proposal Dashboard"/>
<!--          <o-tab-item :value="1" label="Project Dashboard"/>-->
<!--          <o-tab-item :value="2" label="Expiration Dashboard"/>-->
          <o-tab-item :value="3" label="Billing Dashboard"/>
          <o-tab-item :value="4" label="Production Planning"/>
          <o-tab-item :value="5" label="Services Overview"/>
          <o-tab-item :value="6" label="Tasks by Location"/>
          <o-tab-item :value="7" label="Service Level"/>
        </o-tabs >

        <router-view />
    </div>
</template>

<script>
    import {mapActions, mapGetters} from 'vuex'
    import ProposalDashboard from "./tabs/ProposalDashboard";
    import ProjectDashboard from "./tabs/ProjectDashboard";
    import ExpirationDashboard from "./tabs/ExpirationDashboard";
    import BillingDashboard from "./tabs/ExpirationDashboard";
    import ProductionReport from "../../components/modals/ProductionReport";
    import ServicesOverview from "./tabs/services-overview/ServicesOverview";
    import TasksByLocation from "./tabs/TasksByLocation";
    import ServiceLevelReport from "./tabs/ServiceLevelReport";

    export default {
      components: {
        ServiceLevelReport,
        TasksByLocation,
        ServicesOverview,
        ProductionReport, ExpirationDashboard, ProjectDashboard, ProposalDashboard, BillingDashboard},
      data () {
            return {
                activeTab: 0,
                selectedMonth: null,
            }
        },

        mounted() {
            this.openInitialTab()
        },

        methods: {
            sendReminder() {
                this.$swal.fire('Email reminder has been sent to customer')
            },

            changeTab(tabIndex) {
                let subRoutes = [
                    'proposals',
                    'projects',
                    'expirations',
                    'billing',
                    'production-planning',
                    'services-overview',
                    'tasks-by-location',
                    'service-level',
                ]

                this.$router.push({ name: `dashboard.${subRoutes[tabIndex]}` })
            },

            openInitialTab(route_name) {
                this.activeTab = {
                    'dashboard.proposals': 0,
                    'dashboard.projects': 1,
                    'dashboard.expirations': 2,
                    'dashboard.billing': 3,
                    'dashboard.production-planning': 4,
                    'dashboard.services-overview': 5,
                    'dashboard.tasks-by-location': 6,
                    'dashboard.service-level': 7,
                }[route_name || this.$route.name]
            },
        },
        watch: {
            $route(to, from) {
                const route = to.name === 'home' ? 'dashboard.proposals' : to.name
                if(/^dashboard(?:\.[a-z\.-]*)?$/g.test(route)){
                    this.openInitialTab(route)
                }
            },
        },

    }
</script>
